import { render, staticRenderFns } from "./CartAnnulOrder.vue?vue&type=template&id=2fbd0624"
import script from "./CartAnnulOrder.vue?vue&type=script&lang=js"
export * from "./CartAnnulOrder.vue?vue&type=script&lang=js"
import style0 from "./CartAnnulOrder.vue?vue&type=style&index=0&id=2fbd0624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports